import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CoverageVisibilityService } from '../home/coverage-visibility.service';
import { GoogleSearchBarComponent } from 'app/modules/google-search-bar/google-search-bar.component';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher/media-watcher.service';

@Component({
  selector: 'app-coverage-modal',
  standalone: true,
  imports: [CommonModule, SharedMethodsModule, GoogleSearchBarComponent],
  templateUrl: './coverage-modal.component.html',
  styleUrls: ['./coverage-modal.component.scss']
})
export class CoverageModalComponent implements OnInit {
  showModal = false;
  public headerImage: string;
  public headerTitle: string;
  public headerBody: string;
  public headerTextColor: string;
  public isScreenSmall: boolean;
  public style: any;

  private _strapiService = inject(StrapiService);
  private _fuseMediaWatcherService = inject(FuseMediaWatcherService);
  private platformId = inject(PLATFORM_ID);

  constructor(
    private coverageModalService: CoverageVisibilityService,
  ) {
    this.coverageModalService.showModal$.subscribe(show => this.showModal = show);
  }

  ngOnInit(): void {
    this._fuseMediaWatcherService.onMediaChange$.subscribe(({ matchingAliases }) => {
      this.isScreenSmall = !matchingAliases.includes('md');
    });

    // Used to add styling for background images if needed
     if (isPlatformBrowser(this.platformId)) {
    this.style = document.createElement('style');
     }

    // get content from Strapi
    this._strapiService.getHomeHeaderContent()
      .subscribe({
        next: (res: any) => {
          if (this.isScreenSmall) {
            this.headerImage = res.data.mobileImage.url;
          } else {
            this.headerImage = res?.data?.image.url;
          }
          this.headerTitle = res?.data?.headerText;
          this.headerBody = res?.data?.bodyText;
          this.headerTextColor = res?.data?.text_color_hex;

          // Append the style element to the head of the document if needed
          if (isPlatformBrowser(this.platformId)) {
            document.head.appendChild(this.style);
          }
        }
      });
  }

  close() {
    this.coverageModalService.hide();
  }
} 